// This route is used for all pages that are only for app administrators.

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { userIsAppAdmin } from '../../utils/permissionsOptions';

const AppAdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!rest.loggedIn) {
        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
      }
      return userIsAppAdmin(rest.user)
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
    }}
  />
);


function mapStateToProps(state) {
  return {
    loggedIn: state.users.currentUserId && sessionStorage.jwt,
    user: state.users.roster ? state.users.roster[state.users.currentUserId] : null,
  };
}

export default connect(mapStateToProps)(AppAdminRoute);



// WEBPACK FOOTER //
// ./src/components/common/AppAdminRoute.js